/**
 * Collection grid: best sellers first, out-of-stock products after every
 * available product. Walks the collection pages in that sort and restacks
 * the cards, including the infinite-scroll load.
 */
(function () {
  var state = null;

  function grid() {
    return document.querySelector('#filter-results ul[data-tv-stock-sort]');
  }

  function perPage(list) {
    return parseInt(list.getAttribute('data-per-page'), 10) || 16;
  }

  function sortBy() {
    var value = new URLSearchParams(window.location.search).get('sort_by');
    if (!value || value === 'manual') return 'best-selling';
    return value;
  }

  function pageUrl(list, page) {
    var url = new URL(list.getAttribute('data-collection-url'), window.location.origin);
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key === 'page' || key === 'sort_by' || key === 'section_id') return;
      url.searchParams.append(key, value);
    });
    url.searchParams.set('sort_by', sortBy());
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', list.getAttribute('data-section-id'));
    return url;
  }

  function pauseThemePagination() {
    var pagination = document.querySelector('custom-pagination');
    if (!pagination) return;
    pagination.dataset.pauseInfiniteScroll = 'true';
    if (pagination.intersectingTimer) clearInterval(pagination.intersectingTimer);
    if (pagination.paginationObserver) pagination.paginationObserver.disconnect();
  }

  function productId(item) {
    var card = item.querySelector('[data-product-id]');
    return card ? card.getAttribute('data-product-id') : '';
  }

  function sequenceLength() {
    if (!state.done) return state.available.length;
    return state.available.length + state.soldOut.length;
  }

  function sequence() {
    return state.available.concat(state.done ? state.soldOut : []);
  }

  function fetchPage(list) {
    if (state.done || state.fetching) return state.fetching || Promise.resolve();
    state.page += 1;
    var requested = state.page;
    state.fetching = fetch(pageUrl(list, requested).toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('#filter-results ul');
        var found = 0;
        if (source) {
          Array.prototype.forEach.call(source.children, function (item) {
            if (!item.classList.contains('js-pagination-result')) return;
            var id = productId(item);
            if (!id || state.seen[id]) return;
            state.seen[id] = true;
            found += 1;
            var copy = document.importNode(item, true);
            if (item.getAttribute('data-tv-available') === 'false') state.soldOut.push(copy);
            else state.available.push(copy);
          });
        }
        if (!source || found < perPage(list)) state.done = true;
      })
      .catch(function () {
        state.done = true;
      })
      .finally(function () {
        state.fetching = null;
      });
    return state.fetching;
  }

  function collect(list, end) {
    var guard = 0;
    function step() {
      if (sequenceLength() >= end || state.done || guard > 30) return Promise.resolve();
      guard += 1;
      return fetchPage(list).then(step);
    }
    return step();
  }

  function paint(list, items, append) {
    if (!items.length) return;
    if (append) {
      items.forEach(function (item) { list.appendChild(item); });
    } else {
      list.replaceChildren.apply(list, items);
    }
    list.setAttribute('data-tv-stock-ready', 'true');
  }

  function syncButton(list) {
    var button = document.querySelector('.js-pagination-load-more');
    var wrap = document.querySelector('.js-pagination');
    if (!button || !wrap) return;
    if (state.cursor >= sequenceLength() && state.done) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
  }

  function showFrom(list, start, count, append) {
    return collect(list, start + count).then(function () {
      var items = sequence().slice(start, start + count);
      paint(list, items, append);
      state.cursor = start + items.length;
      syncButton(list);
    });
  }

  function render() {
    var list = grid();
    if (!list) return;
    pauseThemePagination();
    state = {
      page: 0,
      done: false,
      fetching: null,
      available: [],
      soldOut: [],
      seen: {},
      cursor: 0
    };
    var page = parseInt(list.getAttribute('data-page'), 10) || 1;
    var size = perPage(list);
    showFrom(list, (page - 1) * size, size, false).catch(function () {
      list.setAttribute('data-tv-stock-ready', 'true');
    });
  }

  function loadMore(event) {
    var button = event.target.closest('.js-pagination-load-more');
    var list = grid();
    if (!button || !list || !state) return;
    event.preventDefault();
    event.stopPropagation();
    if (state.cursor >= sequenceLength() && state.done) return;
    showFrom(list, state.cursor, perPage(list), true);
  }

  function start() {
    render();
    document.addEventListener('click', loadMore, true);
    document.addEventListener('on:facet-filters:updated', render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
